<template>
  <div class="container">
    <div class="card">
      <div class="card-header d-flex justify-content-between align-items-center ps-4 pt-3 pb-4">
        <h5><i class="fa-duotone fa-solid fa-list"></i> Pacientes</h5>
        <argon-button size="sm" color="primary" variant="gradient" @click="openCreatePatientModal">
          <span class="fa-solid fa-plus" />
          Crear Paciente
        </argon-button>
      </div>
      <div class="card-body pt-0">
        <CardData @create-first="openCreatePatientModal" />
      </div>
    </div>
  </div>
  <!-- Mejor usar v-model para controlar la visibilidad del modal -->
  <PatientModal v-model="showPatientModal" :is-edit-mode="false" />
</template>

<script setup>
import { ref } from 'vue';
import CardData from '@/components/CardData.vue';
import PatientModal from '@/components/PatientModal.vue';
import ArgonButton from "@/components/ArgonButton.vue";

// Controla la visibilidad del modal
const showPatientModal = ref(false);

// Función para abrir el modal
const openCreatePatientModal = () => {
  showPatientModal.value = true;
};
</script>
